// @flow
import * as React from 'react';
import ImprovedAlert from './index';

type State = {
  showMessage: string,
};

class ImprovedAlertContainer extends React.Component<null, State> {
  state = {
    showMessage: 'shown',
  };

  componentDidMount() {
    window.setTimeout(() => {
      this.handleClose();
    }, 5000);
  }

  handleClose = () => {
    this.setState({ showMessage: 'hidding' });
    window.setTimeout(() => {
      this.setState({ showMessage: '' });
    }, 500);
  };

  render(): React.Node {
    return <ImprovedAlert showMessage={this.state.showMessage} handleClose={this.handleClose} />;
  }
}

export default ImprovedAlertContainer;



// WEBPACK FOOTER //
// ./app/Serp/components/ImprovedAlert/container.js